import React, { useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Axios from '../utils/axios';
import { RoleAssistant } from '../utils/const';
import { faToEn } from '../utils/numbers';

export function PatientCard(props) {
	const { id } = useParams();
	const { patient } = props;
	const [sent, setSent] = useState(false);
	const history = useHistory();
	const sendPatient = async () => {
		const body = { id };
		const res = await Axios.post(`/patient/next`, body);
		if (res.status === 200) {
			setSent(true);
		}
	};

	return (
		<div className="w-full my-auto mb-5 md:grid md:grid-cols-5 ">
			<div className="col-span-4">
				<PatientDetail />
			</div>
			<div className="grid grid-cols-4 gap-1 md:h-2/5 lg:h-1/3 md:grid-cols-1 md:mx-3 md:gap-4 md:grid-rows-4">
				<Link
					to={`/patient/${patient.id}/create`}
					className="px-2 text-center text-white rounded-lg shadow bg-emerald-800 hover:bg-emerald-600 hover:shadow-xl"
				>
					ایجاد نسخه
				</Link>
				<Link
					to={`/patient/${patient.id}/recipe`}
					className="px-2 text-center text-white rounded-lg shadow bg-emerald-800 hover:bg-emerald-600 hover:shadow-xl"
				>
					ایجاد نسخه PDF
				</Link>
				{localStorage.getItem('role') === RoleAssistant && (
					<Link
						to={`/patient/${patient.id}/service`}
						className="px-2 text-center text-white rounded-lg shadow bg-emerald-800 hover:bg-emerald-600 hover:shadow-xl"
					>
						اضافه کردن خدمت
					</Link>
				)}
				<button
					onClick={() => onDelete()}
					className="px-2 text-center text-white bg-red-700 rounded-lg shadow hover:bg-red-600 hover:shadow-xl"
				>
					حذف بیمار
				</button>
				{id ? (
					<button
						className="px-2 text-center text-white bg-blue-800 rounded-lg shadow hover:bg-blue-600 disabled:bg-blue-100 hover:shadow-xl"
						onClick={() => sendPatient()}
						disabled={sent}
					>
						بیمار بعدی
					</button>
				) : (
					{
						/* <button
            className="px-2 text-center text-white bg-blue-800 rounded-lg shadow h-3/6 md:mx-20 hover:bg-blue-300 disabled:bg-blue-100"
            onClick={() => nextPaitent()}
          >
            بیمار بعد
          </button> */
					}
				)}
			</div>
		</div>
	);
	async function onDelete() {
		const ready = window.confirm('آیا از حذف این بیمار اطمینان دارید؟');

		if (ready) {
			const res = await Axios.delete(`/patient/${id}`);
			if (res.status === 200) {
				history.push('/');
				window.location.reload();
			}
		}
	}

	function PatientDetailRow(props) {
		const { label, value, dbKey: key } = props;
		const [tempValue, setValue] = useState(value);

		const submitChange = async (e, setValue, key) => {
			const value = e.target.value;
			setValue(value);
			if (key === 'national_id' && value.length !== 10) {
				return;
			}

			await Axios.put(`/patient/${id}`, { [key]: value });
		};
		return (
			<div className="text-white ">
				<label
					htmlFor={label}
					className="block mb-2 text-sm font-medium text-gray-100 dark:text-gray-300"
				>
					{label}:{' '}
				</label>
				<input
					type={'text'}
					id={label}
					className="block w-full text-sm  p-2.5 text-center text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
					onChange={(e) => submitChange(e, setValue, key)}
					disabled={!key}
					placeholder={label}
					value={tempValue}
				/>
			</div>
		);
	}

	function PatientDetail() {
		const { rest, description, id, description_assistant } = patient;
		const { drug_history, past_history, birth_date } = rest;
		const [dh, setDh] = useState(drug_history);
		const [ph, setPh] = useState(past_history);
		const [desc, setDesc] = useState(description);
		const [descAssistant, setDescAssistant] = useState(description_assistant);
		const getAge = (age) => {
			const gj_diff = 2021 - 1400;
			const year = new Date().getFullYear();
			const Age = -gj_diff + year - age;
			return Age;
		};

		const Age = ({ birth_date }) => {
			const [tempBd, setBd] = useState(birth_date);

			const submitChange = async (e, setValue, key) => {
				const value = faToEn(e.target.value);
				setValue(value);

				if (value != 4) {
					return;
				}
				await Axios.put(`/patient/${id}`, { [key]: value });
			};
			return (
				<div className="grid grid-cols-1">
					<div className="grid text-white grid-cols ">
						<label className="block mb-2 text-sm font-medium text-gray-100 dark:text-gray-300">
							{tempBd ? (
								<span className="pt-3">
									سن:
									<span className="mx-auto">{getAge(tempBd)} سال</span>
								</span>
							) : (
								<span className="pt-3">سال تولد:</span>
							)}
						</label>
						<input
							type="number"
							className="block w-full text-sm  p-2.5 text-center text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
							onChange={(e) => submitChange(e, setBd, 'birth_date')}
							placeholder="سال تولد"
							value={tempBd}
						/>
					</div>
				</div>
			);
		};

		const submitChange = async (e, setValue, key) => {
			const value = e.target.value;
			setValue(value);
			await Axios.put(`/patient/${id}`, { [key]: value });
		};

		return (
			<div>
				<div className="grid w-full grid-cols-1 gap-1 pb-3 m-auto mb-4 border-b border-dashed md:grid-cols-3">
					<PatientDetailRow label="نام" dbKey="first_name" value={patient.firstName} />
					<PatientDetailRow label="نام خانوادگی" dbKey="last_name" value={patient.lastName} />
					<PatientDetailRow label="شماره تماس" value={patient.tel} />
					<PatientDetailRow label=" کد ملی" dbKey="national_id" value={patient.national_id} />
					<Age birth_date={birth_date} />
				</div>

				<label className="text-white">DH</label>
				<textarea
					value={dh}
					className="w-full rounded shadow-md bg-blueGray-50"
					onChange={(e) => submitChange(e, setDh, 'drug_history')}
				/>
				<label className="text-white">PH</label>
				<textarea
					value={ph}
					className="w-full rounded shadow-md bg-blueGray-50"
					onChange={(e) => submitChange(e, setPh, 'past_history')}
				/>
				<label className="text-white">علت مراجعه</label>

				<textarea
					value={desc}
					className="w-full rounded shadow-md bg-blueGray-50"
					rows={6}
					onChange={(e) => submitChange(e, setDesc, 'description')}
				/>
				{localStorage.getItem('role') === RoleAssistant && (
					<>
						<label className="text-white">توضیحات بیمار(مخصوص منشی): </label>

						<textarea
							value={descAssistant}
							className="w-full rounded shadow-md bg-blueGray-50"
							rows={6}
							onChange={(e) => submitChange(e, setDescAssistant, 'description_assistant')}
						/>
					</>
				)}
			</div>
		);
	}
}
